import { Box, styled } from "@mui/material";
import modelFrameworks from "../../constants/modelFrameworks.json";

const getModelFrameworkColor = (type) => {
  const match = modelFrameworks.find((framework) => framework.value === type);
  return match?.color || "#7180a0"; // fallback default color
};

const ModelFrameworkBox = styled(Box)(({ type }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "4px 12px",
  borderRadius: "12px",
  color: "white",
  backgroundColor: getModelFrameworkColor(type),
  fontWeight: "bold",
  textAlign: "center",
  minWidth: 0,
  whiteSpace: "nowrap",
}));

export default ModelFrameworkBox;
